import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { IFilteredColumn } from "@funcional/react-table-ui";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IExportResponse } from "../contracts/exportResponse";

export interface PreTransactionArgsFilterInput {
  afterDate?: string;
  beforeDate?: string;
  customerCode?: string[];
  id?: number[];
  legacyAuthorizationId?: string[];
  legacyProcessedAt?: string;
  legacySequenceId?: string[];
  programCode?: string[];
  status?: string[];
  type?: string[];
  storeCode?: string[];
}
interface UsePreTransactionsOptions {
  filter?: PreTransactionArgsFilterInput;
  gridFilters?: IFilteredColumn[];
}

export function useExportPreTransactions(filters: IFilteredColumn[]) {
  const { request } = usePbm2Url();
  const options: UsePreTransactionsOptions = {};
  if (filters) {
    const filter: PreTransactionArgsFilterInput = {};
    filters.forEach((filteredColumn: any) => {
      if (filteredColumn.id === "id")
        filter.id = [Number(filteredColumn.value)];
      if (filteredColumn.id === "type") filter.type = [filteredColumn.value];
      if (filteredColumn.id === "status")
        filter.status = [filteredColumn.value];
      if (filteredColumn.id === "customerCode")
        filter.customerCode = [filteredColumn.value];
      if (filteredColumn.id === "storeCode")
        filter.storeCode = [filteredColumn.value];
      if (filteredColumn.id === "legacyIdentifiers.authorizationId")
        filter.legacyAuthorizationId = [filteredColumn.value];
      if (filteredColumn.id === "legacyIdentifiers.sequenceId")
        filter.legacySequenceId = [filteredColumn.value];
      if (filteredColumn.id === "items")
        filter.programCode = filteredColumn.value;
    });

    options.filter = filter;
  }
  return useMutation<IExportResponse, unknown, unknown, unknown>(
    "sendExportPreTransactional:" + JSON.stringify(options),
    async () => {
      const { Transactional_sendExportPreTransactional } = await request(
        gql`
          mutation sendExportPreTransactional(
            $before: String
            $after: String
            $first: Int
            $last: Int
            $filter: Transactional_PreTransactionArgsFilterInput
          ) {
            Transactional_sendExportPreTransactional(
              before: $before
              after: $after
              first: $first
              last: $last
              filter: $filter
            ) {
              processed
              exceeded
              message
            }
          }
        `,
        options
      );
      return Transactional_sendExportPreTransactional as IExportResponse;
    }
  );
}
